<template>
  <div class="vehicle_list">
    <div class="car_item" v-for="(item,index) in vehicleOwnershipList" :key="index">
      <p class="car_info">品牌：{{ item.brandName }}</p>
      <p class="car_info">品系：{{ item.strainName }}</p>
      <p class="car_info">最新购车时间：{{ item.purchaseDate | formatShortDate }}</p>
      <p class="car_info">底盘号：{{ item.batholithNo }}</p>
      <p class="car_info">满意点：{{ item.satisfiedContentName ? item.satisfiedContentName : '暂无' }}</p>
      <p class="car_info">不满意点：{{ item.unsatisfiedContentName ? item.unsatisfiedContentName : '暂无' }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "vehicleOwnership",
  props: ['vehicleOwnershipList']
}
</script>

<style scoped lang="less">

.vehicle_list {
  margin-top: 20px;
  background-color: #F6F6F6;
  padding: 36px 26px;

  .car_item {
    display: flex;
    justify-content: space-around;
    background-color: #EDEDED;
    margin-bottom: 12px;
    align-items: center;
    flex-wrap: wrap;

    .car_info {
      color: #333;
      font-size: 16px;
      margin-bottom: 0;
      height: 70px;
      line-height: 70px;
    }

    &:last-of-type {
      margin-bottom: 0;
    }
  }
}

</style>